"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.updateMovementTypeSchema = exports.createMovementTypeSchema = exports.movementTypeShape = void 0;
const zod_1 = require("zod");
exports.movementTypeShape = {
    movementCode: zod_1.z.string().min(1).max(30),
    movementName: zod_1.z.string().min(1).max(150),
    category: zod_1.z.enum(['TRANSFER', 'ISSUE', 'CONSUMPTION', 'ADJUSTMENT']),
    sourceLocationTypeCode: zod_1.z.string().max(30).optional(),
    destinationLocationTypeCode: zod_1.z.string().max(30).optional(),
    destinationIsInventoryLocation: zod_1.z.boolean(),
    requiresApproval: zod_1.z.boolean().default(false),
    financialImpact: zod_1.z.boolean().default(false),
    autoJournalEntry: zod_1.z.boolean().default(false),
    patientLinked: zod_1.z.boolean().default(false),
    departmentLinked: zod_1.z.boolean().default(false),
    isActive: zod_1.z.boolean().default(true),
};
exports.createMovementTypeSchema = zod_1.z.object(exports.movementTypeShape);
exports.updateMovementTypeSchema = exports.createMovementTypeSchema.partial();
//# sourceMappingURL=movement-type.schema.js.map